import styled from "styled-components"

export const Image = styled.img`
  width: auto;
  max-height: 100%;
`